/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Resource Manager Service
 * API for managing organizations, projects, and listing resources within projects.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudResourcemanagerResourceListResponseFromJSON, HashicorpCloudResourcemanagerResourceTestIamPermissionsRequestToJSON, HashicorpCloudResourcemanagerResourceTestIamPermissionsResponseFromJSON, } from '../models';
/**
 *
 */
export class ResourceServiceApi extends runtime.BaseAPI {
    /**
     * List lists the resources the caller has access to.
     */
    async resourceServiceListRaw(requestParameters) {
        const queryParameters = {};
        if (requestParameters.scopeType !== undefined) {
            queryParameters['scope.type'] = requestParameters.scopeType;
        }
        if (requestParameters.scopeId !== undefined) {
            queryParameters['scope.id'] = requestParameters.scopeId;
        }
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/resource-manager/2019-12-10/resources`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudResourcemanagerResourceListResponseFromJSON(jsonValue));
    }
    /**
     * List lists the resources the caller has access to.
     */
    async resourceServiceList(scopeType, scopeId, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.resourceServiceListRaw({ scopeType: scopeType, scopeId: scopeId, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * TestIamPermissions returns a subset of the request permissions the calling principal has on the resource.
     */
    async resourceServiceTestIamPermissionsRaw(requestParameters) {
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling resourceServiceTestIamPermissions.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/resource-manager/2019-12-10/resources/test-iam-permissions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HashicorpCloudResourcemanagerResourceTestIamPermissionsRequestToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudResourcemanagerResourceTestIamPermissionsResponseFromJSON(jsonValue));
    }
    /**
     * TestIamPermissions returns a subset of the request permissions the calling principal has on the resource.
     */
    async resourceServiceTestIamPermissions(body) {
        const response = await this.resourceServiceTestIamPermissionsRaw({ body: body });
        return await response.value();
    }
}
/**
    * @export
    * @enum {string}
    */
export var ResourceServiceListScopeTypeEnum;
(function (ResourceServiceListScopeTypeEnum) {
    ResourceServiceListScopeTypeEnum["UNKNOWN"] = "UNKNOWN";
    ResourceServiceListScopeTypeEnum["ORGANIZATION"] = "ORGANIZATION";
    ResourceServiceListScopeTypeEnum["PROJECT"] = "PROJECT";
})(ResourceServiceListScopeTypeEnum || (ResourceServiceListScopeTypeEnum = {}));
